var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Mei Story",
            "bg": "/images/board/story/visual.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [!_vm.$route.params._board ? _c('board-list', {
    attrs: {
      "code": "story",
      "locale": "ko",
      "skin": "card-ko"
    }
  }) : _c('board-view', {
    attrs: {
      "code": "story",
      "_id": _vm.$route.params._board,
      "skin": "card-ko"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }